import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationVersionsService } from '@services/application-version/application-versions.service';
import { DataTableEvent } from '../../../components/data-table/data-table.component';
import { DialogService } from '@services/dialog/dialog.service';
import moment from 'moment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { TagVersionComponent } from './tag-version/tag-version.component';

@Component({
    selector: 'app-application-version',
    templateUrl: './application-version.component.html',
    styleUrls: ['./application-version.component.scss'],
    providers: [ApplicationVersionsService],
    standalone: false
})
export class ApplicationVersionComponent implements OnInit {

  public title = 'Application Versions : ';
  public variant;

  public params;
  public columns = [
    {
      prop: 'created', valueTransformer: function(date) {
        if (!date) { return null }
        return moment(date).format('DD-MM-YYYY  HH:mm');
      }
    },
    {
      prop: 'updated', valueTransformer: function(date) {
        if (!date) { return null }
        return moment(date).format('DD-MM-YYYY  HH:mm');
      }
    },
    { prop: 'buildNumber' },
    {
      prop: 'versionTags', name: 'Version Tag', valueTransformer: function(version) {
        if (!version || !version[0]) { return null}
        return version[0]
      }
    },
    { validate: 'versionTags', name: 'Activated', icon: 'check_box' }
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public applicationVersionsService: ApplicationVersionsService,
    private snackbar: SnackbarService,
    private dialogService: DialogService,
    private dialog: MatDialog,
  ) {
    this.variant = this.route.snapshot.params['variant'];
    this.title += this.variant;

  }

  ngOnInit() {
    this.params = {
      variant: this.variant,
      $sort: { _id: -1 }
    }
  }

  public onCustom(event: DataTableEvent) {

    this.applicationVersionsService.get(event.row._id).then(applicationVersion => {
      if (applicationVersion.versionTags && applicationVersion.versionTags.length) {
        this.dialogService
          .confirm('Disable this version?')
          .then(res => {
            if (!res) {
              return;
            }
            applicationVersion.versionTags = [];
            this.save(event.row._id, applicationVersion);
          });
      } else {
        this.openTagVersionDialog().then(result => {
          if (result && result.tagVersion) {
            applicationVersion.versionTags = result.tagVersion;
            this.save(event.row._id, applicationVersion);
          }
        });
      }
    })

  }

  public openTagVersionDialog(): Promise<any> {
    let dialogRef: MatDialogRef<TagVersionComponent>;
    dialogRef = this.dialog.open(TagVersionComponent, { width: '400px', height: '300px' });

    return dialogRef.afterClosed().toPromise().then(result => {
      return Promise.resolve(result);
    });
  }

  public save(id, applicationVersion) {
    this.applicationVersionsService.update(id, applicationVersion).then(result => {
      this.snackbar.success('successfully updated application version: ' + result._id);
      this.ngOnInit();
    }, err => {
      this.snackbar.error('could not update application version: ' + err);
    });
  }

}
